import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { DELETE_TALENT_BOARD_COMMENT } from '@bloomays-lib/adapter.api-talent';
import { Logger } from '../services/service-logger';

const logger = Logger('useDeleteTalentBoardComment');

type DeleteTalentBoardCommentVariables = {
  id: string;
};

export const useDeleteTalentBoardComment = () => {
  const [deleteTalentBoardCommentMutation, { loading, error }] = useMutation<
    { deleteTalentBoardComment: boolean },
    DeleteTalentBoardCommentVariables
  >(DELETE_TALENT_BOARD_COMMENT, {
    context: { clientName: 'api.talents' },
  });

  const execute = useCallback(
    async (variables: DeleteTalentBoardCommentVariables): Promise<boolean> => {
      try {
        const result = await deleteTalentBoardCommentMutation({
          variables,
        });
        return result.data?.deleteTalentBoardComment ?? false;
      } catch (err) {
        logger.error('Error deleting talent board comment', variables, err as Error);
        return false;
      }
    },
    [deleteTalentBoardCommentMutation],
  );

  return {
    deleteTalentBoardComment: execute,
    loading,
    error,
  };
};

export default useDeleteTalentBoardComment;
